import { RegisterPayload } from 'models/endpoints-payload'
import { RegisterResponse } from 'models/endpoints-respone'
import { DomainType } from 'models/cookies'

import { promiseWrapper } from 'utils/promise'

declare const USER_BASE_URL_WT: string
declare const BIZ_BASE_URL_WT: string

export const registerUser = (payload: RegisterPayload, domainType: DomainType = 'user'): Promise<RegisterResponse> => {
  return promiseWrapper<RegisterResponse, RegisterPayload>(
    `${domainType === 'user' ? USER_BASE_URL_WT : BIZ_BASE_URL_WT}/api/public/registration`,
    'POST',
    payload,
    {
      withCredentials: true,
    },
  )
}
